import type { ApiResponse } from 'apisauce';
import type { ResponseModel } from '../../shared/interfaces/response-model.interface';
import type { ErrorInfo } from '../../shared/interfaces/error-info.interface';
import api from '../../shared/services/utils/api/api.service';
import errorHelper from '../../shared/services/utils/api/error-helper.service';
import { getModuleName } from '../../UserModule/shared/services/user.service';

export function getAllUsers(query: any, offset: number, limit: number): Promise<any | ErrorInfo> {
  return api
    .getUsers(query, offset, limit)
    .then((response: ApiResponse<ResponseModel<any>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data?.data && data?.count) {
          return { data: data?.data, count: data?.count };
        }

        if (query.export) {
          return data;
        }
        return errorHelper(0, '', getModuleName(), (api.getReservations as any).displayName);
      }
      return errorHelper(
        Number(response.status),
        response.data?.errorCode ? String(response.data.errorCode || '') : response.problem,
        getModuleName(),
        (api.getReservations as any).displayName
      );
    });
}
